import { Paper, Typography } from "@mui/material";
import KeywordsImprovementTable from "./KeywordsImprovementTable";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";

const tableHeadings = {
  keyword_name: "KeyWord",
  matchtype: "Match Type",
  traffic_source: "Traffic Source",
  adgroup_name: "Ad Group",
  campaign_name: "Campaign",
  lp_exp_score_weight: "LP Experience",
  cost: "Cost",
  quality_score_weight: "QS",
};

const KeywordsImprovement = () => {
  const { performanceByKeywords } = useSelector(
    (state: any) => state.landingPageExperience
  );


// const sortedData = performanceByKeywords?.length > 0
//   ? [...performanceByKeywords]
//       // First: sort cost desc, then lp_exp_score_weight asc
//       .sort((a, b) => {
//         if (b.cost !== a.cost) return a.cost - b.cost; // Cost DESC
//         return a.lp_exp_score_weight - b.lp_exp_score_weight; // LP EXP ASC
//       })
//       // Then: calculate score
//       .map(item => ({
//         ...item,
//         score: item.cost + item.lp_exp_score_weight
//       }))
//       // Finally: sort by score ASC
//       .sort((a, b) => a.score - b.score).slice(0, 5)
//   : [];

// const sortedData = performanceByKeywords?.length > 0
//   ? [...performanceByKeywords]
//       .sort((a, b) => {
//         // High cost first
//         if (b.cost !== a.cost) return b.cost - a.cost;
//         // Among same cost, low LP EXP first
//         return a.lp_exp_score_weight - b.lp_exp_score_weight;
//       })
//   : [];

  return (
    <>
      <Paper sx={{ mb: "20px" }}>
        <Box sx={{ padding: "8px 16px" }}>
          <Typography fontSize={24}>Keywords For Improvement</Typography>
          <Typography sx={{ color: "#00000099" }}>
            5 keywords with highest cost but lowest landing page experience
            score.
          </Typography>
        </Box>
        {performanceByKeywords?.length > 0 ? (
          <>
            <KeywordsImprovementTable
              tableHeadings={tableHeadings}
              records={performanceByKeywords}
            />
          </>
        ) : (
          <Typography
            fontSize={20}
            sx={{ textAlign: "center", padding: "8px 16px" }}
          >
            No data to display
          </Typography>
        )}
      </Paper>
    </>
  );
};

export default KeywordsImprovement;
